import { Component, h, Prop } from '@stencil/core';
import svgs from './icon-set';

const SOCIAL = ['facebook', 'twitter', 'instagram', 'pinterest', 'linkedin', 'youtube', 'vimeo', 'weibo', 'qq', 'wechat'];
@Component({
  tag: 'hd-icon',
  styleUrl: 'hd-icon.pcss',
  shadow: true,
})
export class HdIcon {
  @Prop({ reflect: true }) svg: string = '';
  @Prop() isSelected: boolean = false;
  @Prop() circle: boolean = false;
  @Prop() fill: string = 'transparent';
  @Prop() stroke: string = '#929292';
  @Prop({ reflect: true }) width: string;
  @Prop({ reflect: true }) height: string;

  render() {
    let svgClass = this.circle ? 'circle' : '';
    if (SOCIAL.includes(this.svg)) svgClass += ` ${this.svg}`;
    const customStyle = !this.circle ? { fill: this.fill, stroke: this.stroke } : {};
    const customDimensions = {
      ...(this.width ? { width: this.width } : {}),
      ...(this.height ? { height: this.height } : {}),
    }

    if (!svgs[this.svg]) {
      console.error(`Hadid error: Icon "${this.svg}" not found`)
      return null
    }

    return (
      <svg class={svgClass} viewBox={svgs[this.svg].viewBox} style={{...customStyle, ...customDimensions}}
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {svgs[this.svg].svg}
      </svg>
    )
  }
}
